import { ChevronLeft, X } from 'lucide-react';

export interface CarouselHeaderProps {
  /** 1-indexed step number — rendered as "{stepIndex} of {totalSteps}". */
  stepIndex: 1 | 2 | 3;
  totalSteps?: number;
  /** Omit to hide the back chevron — used on Step 1 (YAR-238 AC 5). */
  onBack?: () => void;
  onClose: () => void;
}

/**
 * Shared header row for the walkthrough carousel (YAR-238 AC 5): back
 * chevron (left, only on Steps 2/3), step indicator (center), and X
 * (right, all steps). The X behaviour is owned by the caller — Step 1
 * needs special handling for the Edit Senders sub-state confirmation
 * (AC 10), Steps 2/3 just close + toast (AC 11).
 */
export function CarouselHeader({
  stepIndex,
  totalSteps = 3,
  onBack,
  onClose,
}: CarouselHeaderProps) {
  return (
    <div className="flex items-center justify-between min-h-[40px]">
      <div className="w-10 flex items-center">
        {onBack && (
          <button
            type="button"
            onClick={onBack}
            aria-label="Back"
            className="w-10 h-10 flex items-center justify-center rounded-sm cursor-pointer"
          >
            <ChevronLeft
              size={24}
              className="text-icon-default"
            />
          </button>
        )}
      </div>
      <p className="text-base font-medium text-foreground">
        {stepIndex} of {totalSteps}
      </p>
      <div className="w-10 flex items-center justify-end">
        <button
          type="button"
          onClick={onClose}
          aria-label="Close walkthrough"
          className="w-10 h-10 flex items-center justify-center rounded-sm cursor-pointer"
        >
          <X
            size={24}
            className="text-icon-default"
          />
        </button>
      </div>
    </div>
  );
}
